import { SignLeaseAgreementResponse } from '../../gql/graphql';
import { createForbiddenErrorMessage, createUnauthorizedErrorMessage } from '../../helpers/security/security';
import applicationFormService from '../../services/applicationForm.service';
import { NetworkError } from '../../state-machine/actions/genericActions';
import { setAppStatusParams } from '../../helpers/url/url.helpers';

const signLeaseAgreement = async (applicationId: number | undefined, ipAddress?: string): Promise<SignLeaseAgreementResponse> => {
  try {
    if (applicationId === undefined) {
      throw new Error('failed to sign lease agreement: applicationId is undefined');
    }

    const { data } = await applicationFormService.signLeaseAgreement({ applicationId: applicationId.toString(), ipAddress: ipAddress, isSigned: true });
    setAppStatusParams('docsSigned');
    return data?.signLeaseAgreement as SignLeaseAgreementResponse;
  } catch (err: any) {
    const error = {} as NetworkError;
    switch (err?.networkError?.statusCode) {
      case 403:
        error.forbiddenError = createForbiddenErrorMessage(err);
        break;
      case 401:
        error.unauthorizedError = createUnauthorizedErrorMessage(err);
        break;
      default:
        error.errorGeneral = err;
        break;
    }
    throw error;
  }
};

export default signLeaseAgreement;
